enum Role {
    Null,
    User,
    Admin
}

export default Role;



// WEBPACK FOOTER //
// ./src/domain/Role.ts